import Link from 'next/link';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { BlogHomepageCardPlatformProps } from 'src/types';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';

const Platform = (props: BlogHomepageCardPlatformProps) => {
  const { name, description, slug, bannerImage, bgColor } = props;
  return (
    <Link href="/blog/platforms/[platform]" as={`/blog/platforms/${slug}/`}>
      <a>
        <div
          className={ivclass(
            'iv-px-[38px] iv-py-[32px] ',
            'sm:iv-py-[18px] sm:iv-px-[24px]',
            'iv-rounded-3xl',
            'iv-h-[560px] sm:iv-h-[450px] iv-w-[380px] sm:iv-w-[320px]',
            'iv-bg-no-repeat iv-bg-cover iv-bg-center',
            'iv-cursor-pointer',
            'iv-relative iv-overflow-hidden',
          )}
          style={{
            background: bgColor,
          }}
        >
          <ImageComponent
            elementype="imagekit"
            loading="lazy"
            src={bannerImage?.url || ''}
            width={210}
            height={170}
            alt={slug}
            className={ivclass(
              'iv-absolute',
              'iv-bottom-0 iv-right-0',
              'iv-object-cover',
              'iv-z-10',
              'iv-h-[310px] sm:iv-h-[263px] iv-w-[340px] sm:iv-w-full',
            )}
          />
          <div
            className={ivclass(
              'iv-text-heading-s sm:iv-text-heading-3xs iv-font-extrabold ',
              'iv-text-white-90',
              'iv-mb-10 sm:iv-mb-4',
              'iv-z-20',
            )}
          >
            {name}
          </div>
          <div
            className={ivclass(
              'iv-text-white-70 ',
              'iv-text-body-3xl sm:iv-text-body-xl',
              'iv-font-medium',
              'iv-absolute',
              'iv-z-20',
            )}
          >
            {description}
          </div>
        </div>
      </a>
    </Link>
  );
};

export default Platform;
